import React, { useCallback } from 'react';

import { RovoSettingsModal } from '@atlassian/rovo-settings-modal/ui/rovo-settings-modal';

import { ConnectorPromoBanner } from './ConnectorPromoBanner.tsx';
import type { ConnectorPromoBannerModel } from './connectorPromoBannerModel.ts';

/** Attributed separately from the preview panel's "Manage connections" entry point. */
const TEAMWORK_GRAPH_MODAL_SURFACE = 'confluence-teamwork-graph-modal';
/** The connector dialog's "Connect apps" tab — the banner is only ever about that one. */
const APPS_TAB_ID = 'discovery';

// The dialog's render-prop callback cannot own hooks, so bind the click in a component.
const ConnectorPromoBannerDialogTrigger = ({
	banner,
	open,
}: {
	banner: ConnectorPromoBannerModel;
	open: (options: { defaultTab: string }) => void;
}): React.JSX.Element => {
	const { selection, apps, onClick } = banner;
	const handleClick = useCallback(() => {
		onClick();
		open({ defaultTab: APPS_TAB_ID });
	}, [onClick, open]);

	return (
		<ConnectorPromoBanner
			variant={selection.variant}
			topAppPercent={
				selection.variant === 'orgConnectedApps' ? selection.topApp.percent : undefined
			}
			apps={apps}
			onClick={handleClick}
		/>
	);
};

export const ConnectorPromoBannerWithDialog = ({
	banner,
}: {
	banner: ConnectorPromoBannerModel;
}): React.JSX.Element => (
	<RovoSettingsModal
		product="confluence"
		cloudId={banner.cloudId}
		surface={TEAMWORK_GRAPH_MODAL_SURFACE}
	>
		{({ open }) => <ConnectorPromoBannerDialogTrigger banner={banner} open={open} />}
	</RovoSettingsModal>
);
